import React from "react";
import ModalBasic from "../../components/ModalBasic.jsx";
import { PrimaryButton } from "../../components/Buttons.jsx";
import config from '@/config';
import SubscriptionDot from "./subscriptionDot.jsx";

const SubscriptionModal = ({ merchant, subscription, isOpen, onClose }) => {

  return (
    <ModalBasic
      modalOpen={isOpen}
      setModalOpen={onClose}
      width={"2xl"}
      title={"Subscription Details"}
    >
      {subscription && (
        <div className="w-full">
          <PrimaryButton
            onClick={() => {
              window.open(
                `https://dashboard.stripe.com/${
                  config.environment === "development" ? "test/" : ""
                }subscriptions/${subscription.id}`,
                "_blank"
              );
            }}
          >
            View on Stripe
          </PrimaryButton>
          <table className={"mt-4 text-sm"}>
            <tbody>
              <tr>
                <td className={"pr-4 pb-2 font-semibold"}>ID</td>
                <td className={"pb-2"}>{subscription.id}</td>
              </tr>
              <tr>
                <td className={"pr-4 pb-2 font-semibold"}>Status</td>
                <td className={"pb-2"}>
                  <SubscriptionDot subscription={subscription} />{" "}
                  {subscription.status}
                </td>
              </tr>
              <tr>
                <td className={"pr-4 pb-2 font-semibold"}>Current Period</td>
                <td className={"pb-2"}>
                  {" "}
                  {new Date(
                    subscription?.items?.data[0]?.current_period_start * 1000
                  ).toLocaleDateString()}{" "}
                  -{" "}
                  {new Date(
                    subscription?.items?.data[0]?.current_period_end * 1000
                  ).toLocaleDateString()}
                </td>
              </tr>
              <tr>
                <td className={"pr-4 pb-2 font-semibold"}>Customer</td>
                <td className={"pb-2"}>{subscription.customer.email}</td>
              </tr>
              <tr>
                <td className={"pr-4 pb-2 font-semibold"}>Description</td>
                <td className={"pb-2"}>{subscription.description}</td>
              </tr>
              <tr>
                <td className={"pr-4 pb-2 font-semibold"}>Licenses</td>
                <td className={"pb-2"}>
                  {subscription.items.data[0].quantity}
                </td>
              </tr>
              <tr>
                <td className={"pr-4 pb-2 font-semibold"}>Payment Method</td>
                <td className={"pb-2"}>
                  {merchant.stripe_card_brand}{" "}
                  {merchant.stripe_card_last4} (
                  {merchant.stripe_card_exp_month}/
                  {merchant.stripe_card_exp_year}){" "}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </ModalBasic>
  );
};

export default SubscriptionModal;
